import TextCreate from 'core/display/simple/Text'
import { gsap } from 'gsap'
import { FormatService } from 'services/FormatService'
import { signal } from 'services/SignalsService'
import { time } from 'settings/custom/rolling'

export default class CascadeCurrentWinText extends TextCreate {
  constructor(data) {
    super(data)

    this.tween = { value: 0 }

    signal.on('CASCADE-WIN-UPDATE-COUNTER', this.animate.bind(this))
    signal.on('ACTION:REQUEST-SPIN', this.reset.bind(this))
    signal.on('BUTTON:start', this.reset.bind(this))
    signal.on('BUTTON:close', this.reset.bind(this))
  }

  onUpdate() {
    const value = FormatService.currency(~~this.tween.value)
    super.update(value, false)
  }

  reset() {
    gsap.killTweensOf(this.tween)
    this.tween.value = 0
    this.onUpdate()
  }

  animate({ type, amount }) {
    const value = amount
    const winTween = gsap.to(this.tween, time[type], {
      value, onUpdate: () => {
        this.onUpdate()
      }, onComplete: () => {
        winTween.kill()
      },
    })
  }
}
